/** activeMonth ("2025-10") -> "10月期" 表記。想定外の形式はそのまま返す。 */
export function formatMonthLabel(activeMonth: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(activeMonth);
  if (match) {
    const month = Number(match[2]);
    return `${month}月期`;
  }
  return activeMonth;
}

export function formatStatusLabel(status: "open" | "closed"): string {
  return status === "open" ? "受付中" : "受付終了";
}
